export enum ELifeCycleStatus {
    NotCompletedAndNotPositioned,
    CompletedAndNotPositioned,
    CompletedAndPositionedNotSaved,
    CompletedAndPositioned
}